import { render, staticRenderFns } from "./GuidesSection.vue?vue&type=template&id=39084d7e&scoped=true"
import script from "./GuidesSection.vue?vue&type=script&lang=js"
export * from "./GuidesSection.vue?vue&type=script&lang=js"
import style0 from "./GuidesSection.vue?vue&type=style&index=0&id=39084d7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39084d7e",
  null
  
)

export default component.exports